/* eslint-disable consistent-return */
// import { formatTimeRemaining } from '../../../helper';
import { useEffect, useState } from 'react';

type TimeUnit = 'seconds' | 'minutes' | 'hours' | 'days';

interface TimeRemainingProps {
  time: number;
  unit?: TimeUnit;
  onTimeExpired: () => void;
}

const convertToSeconds = (time: number, unit: TimeUnit = 'seconds'): number => {
  switch (unit) {
    case 'days':
      return time * 24 * 60 * 60;
    case 'hours':
      return time * 60 * 60;
    case 'minutes':
      return time * 60;
    case 'seconds':
    default:
      return time;
  }
};

const TimeRemaining = ({ time, onTimeExpired, unit = 'seconds' }: TimeRemainingProps) => {
  const initialSeconds = convertToSeconds(time, unit);
  const [currentTime, setCurrentTime] = useState<number>(initialSeconds);

  useEffect(() => {
    // I want to set time 24 hours remaining if the time is 0
    if (time <= 0) {
      setCurrentTime(24 * 60 * 60);
    }
    if (currentTime <= 0) {
      onTimeExpired();
      return;
    }
    const interval: NodeJS.Timeout = setInterval(() => {
      setCurrentTime((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [time, currentTime]);

  const formatBasedOnUnit = (totalSeconds: number): string => {
    switch (unit) {
      case 'days': {
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        return `${days}d ${hours}h ${minutes}m ${seconds}s`;
      }
      case 'hours': {
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        return `${hours}h ${minutes}m ${seconds}s`;
      }
      case 'minutes': {
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        return `${minutes}m ${seconds}s`;
      }
      case 'seconds':
      default:
        return `${totalSeconds}s`;
    }
  };

  return <>{currentTime > 0 ? formatBasedOnUnit(currentTime) : 'few seconds'}</>;
};

export default TimeRemaining;
